const ApiAttributesKeys = {
  chapterIdKey: 'chapter_id',
  readingNameKey: 'name',
  correctChoiceKey: 'right_choice',
  readingIdKay: 'reading_id',
  readingIdParamsKey: 'readingId',
  questionIdKey: 'id',
  questionIdParamsKey: 'questionId',
  answerKey: 'answer',
  questionKey: 'question',
  isAttemptedKey: 'isAttempted',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/QuestionView/ApiAttributesKays.js